import { render, staticRenderFns } from "./CreateInvestorForm.vue?vue&type=template&id=9f58d362&scoped=true&"
import script from "./CreateInvestorForm.vue?vue&type=script&lang=js&"
export * from "./CreateInvestorForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateInvestorForm.vue?vue&type=style&index=0&id=9f58d362&prod&lang=css&"
import style1 from "./CreateInvestorForm.vue?vue&type=style&index=1&id=9f58d362&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f58d362",
  null
  
)

export default component.exports